/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdRolesQueryResponse,
  GetApiV1PersonIdRolesPathParams,
  GetApiV1PersonIdRoles401,
  GetApiV1PersonIdRoles404,
  GetApiV1PersonIdRoles500,
} from "../../types/personRegisterController/GetApiV1PersonIdRoles.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdRoles } from "../../clients/personRegisterController/getApiV1PersonIdRoles.ts";

export const getApiV1PersonIdRolesQueryKey = (
  id: GetApiV1PersonIdRolesPathParams["id"],
) => [{ url: "/api/v1/person/:id/roles", params: { id: id } }] as const;

export type GetApiV1PersonIdRolesQueryKey = ReturnType<
  typeof getApiV1PersonIdRolesQueryKey
>;

export function getApiV1PersonIdRolesQueryOptions(
  id: GetApiV1PersonIdRolesPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdRolesQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdRolesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdRoles401
      | GetApiV1PersonIdRoles404
      | GetApiV1PersonIdRoles500
    >,
    GetApiV1PersonIdRolesQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdRoles(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna as flags de papéis (student, teaching staff, etc.) da pessoa. **(Requer Authorization para autenticação)**
 * @summary Obter papéis da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/roles}
 */
export function useGetApiV1PersonIdRoles<
  TData = GetApiV1PersonIdRolesQueryResponse,
  TQueryData = GetApiV1PersonIdRolesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdRolesQueryKey,
>(
  id: GetApiV1PersonIdRolesPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdRolesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdRoles401
          | GetApiV1PersonIdRoles404
          | GetApiV1PersonIdRoles500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1PersonIdRolesQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdRolesQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdRoles401
      | GetApiV1PersonIdRoles404
      | GetApiV1PersonIdRoles500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
